import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActiveUserSessionService } from 'services/activeusersession.service';
import { AlertService } from 'services/alert.service';
import { CoverageService } from 'services/coverage.service';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { ForgotpasswordComponent } from '../login/forgotpassword.component';

@Component({
  selector: 'app-otherlocationaddress',
  templateUrl: './otherlocationaddress.component.html',
  styleUrls: ['./otherlocationaddress.component.scss']
})
export class OtherlocationaddressComponent implements OnInit {
  otherLocatinAddressForm: FormGroup;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ForgotpasswordComponent>,
  private navigationService: NavigationService,
  private coverageService: CoverageService,
  private activeUserSessionService: ActiveUserSessionService,
  private alertService: AlertService)
  { 
    this.initializeValidators();
  }

  ngOnInit() {
  }

  initializeValidators() {
    this.otherLocatinAddressForm = new FormGroup({
      unitNo: new FormControl('', [Validators.required]),
      unitName: new FormControl('', [Validators.required]),
    });
    
  }
  

  onSave() {
    if (this.otherLocatinAddressForm.valid) {      
      this.coverageService.getAddressByUnitNoAndName(this.otherLocatinAddressForm.value).subscribe(result => {
        if (result) {
          this.activeUserSessionService.createUnitName(this.otherLocatinAddressForm.value.unitName);
          this.activeUserSessionService.createUnitNo(this.otherLocatinAddressForm.value.unitNo)
          this.dialogRef.close(result);        
          }
      });
    } else {
      this.validateFormControl();
    }
  }

  validateFormControl() {
    Object.keys(this.otherLocatinAddressForm.controls).forEach(field => {
      const control = this.otherLocatinAddressForm.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }
  onCancel() {
    this.dialogRef.close();
  }




}
